module.exports = __webpack_public_path__ + "static/img/xls.ade5c272.png";